import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ProductSpecification from './product-specification';
import ProductSpecificationDetail from './product-specification-detail';
import ProductSpecificationUpdate from './product-specification-update';
import ProductSpecificationDeleteDialog from './product-specification-delete-dialog';

const ProductSpecificationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ProductSpecification />} />
    <Route path="new" element={<ProductSpecificationUpdate />} />
    <Route path=":id">
      <Route index element={<ProductSpecificationDetail />} />
      <Route path="edit" element={<ProductSpecificationUpdate />} />
      <Route path="delete" element={<ProductSpecificationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ProductSpecificationRoutes;
